<div [ngClass]="{
    'w-100 full-height-mobile position-relative z-max': !viewportService.isLargeViewPort(),
    'h-100': viewportService.isLargeViewPort()}"
     class="d-flex flex-column w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
    <div [ngClass]="{'w-100': !viewportService.isLargeViewPort(), 'width-400px': viewportService.isLargeViewPort()}"
         class="row background-light-gray border-bottom border-dark-subtle p-3 m-0 z-max d-flex align-items-center height-details-header">
        <div (click)="back()"
             class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2"
             type="button">
            <i class="fa-solid fa-chevron-left color-secondary-information m-auto"></i>
        </div>
        <div class="col-2 m-0 d-flex justify-content-center">
            <app-bluetooth-svg [status]="Status.ONLINE"></app-bluetooth-svg>
        </div>
        <div class="col-8 m-0">
            <div class="fw-bold">Alter {{ id() | slice:-5 }}</div>
        </div>
        <div (click)="close()"
             class="col-1 pt-4 pb-4 btn text-reset m-auto rounded-2"
             type="button">
            <i class="fa-solid fa-x color-secondary-information m-auto"></i>
        </div>
    </div>
    <div class="d-flex flex-column p-3 gap-3 w-100 background-white overflow-y-auto overflow-x-hidden no-scroll-bar">
        <div>
            <div class="h5">Assigned animals</div>
            <div>
                <div class="d-flex justify-content-between m-2">
                    <div class="form-group">
                        <div class="form-check ps-4 pt-1">
                            <input (change)="checkUncheckAllAnimals()"
                                class="form-check-input p-2"
                                id="selectAll"
                                type="checkbox">
                            <label class="form-check-label" for="selectAll">Select All</label>
                        </div>
                    </div>
                </div>
                <div class="flex-grow-1">
                    @if (paddocks() === undefined) {
                        <div class="text-center p-3 opacity-50">
                            Paddocks loading...
                            <app-spinner [loading]="true"></app-spinner>
                        </div>
                    }
                    @for (paddock of paddocks(); track paddock.id) {
                        <app-paddock [focusOnClick]="false"
                                    [animals]="getAnimalsFor(paddock)"
                                    [paddock]="paddock"></app-paddock>
                    }
                    @if (animalsStore.unassignedAnimals().length > 0) {
                        <app-paddock [focusOnClick]="false"
                                    [animals]="animalsStore.unassignedAnimals()"
                                    [paddock]="unassignedPaddock"></app-paddock>
                    }
                </div>
            </div>
        </div>
        <app-generic-button
            (click)="applyChanges()"
            description="Apply changes to bluetooth proximity sensor"
            [alwaysShowText]="true"
            [buttonText]="'Apply changes'"
            [disabled]="loading() || !networkStatusStore.isOnline()"
            [primaryIcon]="'fa-solid fa-check'"/>
        <app-generic-button
            (click)="removeAssociation()"
            description="Remove association for bluetooth proximity sensor"
            [alwaysShowText]="true"
            [buttonClass]="'btn-danger btn-danger-shadow'"
            [buttonText]="'Delete'"
            [disabled]="loading() || !networkStatusStore.isOnline()"
            [primaryIcon]="'fa-solid fa-trash-can'"/>
    </div>
</div>
